<template>
    <div class="businessunit-popup" v-bind:style="{top: posy + 'px', left: posx + 'px', display: toggled ? 'inline-block' : 'none'}" v-if="toggled">
        <div class="background" v-on:click="Close()"></div>
        <div class="header">
            <div class="label">Einen neuen Bereich anlegen</div>
        </div>
        <div>
            <b-container fluid>
                <div>
                    <b-form-group label-cols="4" label-cols-lg="2" label="Name" label-for="cr1">
                        <b-form-input id="cr1" v-model="newBusinessUnitName" type="text" v-on:input="SanitizeInput()"></b-form-input>
                    </b-form-group> 
                </div>
            </b-container>
            <b-row>
                <b-col>
                    <div class="footer right">
                        <div class="button next" @click="createBusinessUnit($event)" v-if="!existing">
                            <div class="label">Hinzufügen</div>
                        </div>
                        <div class="next text-muted"  v-if="existing">
                          <small>Dieser Bereich existiert bereits!</small>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
    </div>
</template>


<script>
    export default {
        name: 'businessunitpopup',
        components: {
        },
        data(){
            return{
                toggled: false,
                posx: 0,
                posy: 0,
                newBusinessUnitName: '',
                existing: false,
                createWithSpotAndSkill: true,
            }
        },
        created () {
        },
        destroyed(){
        },
        methods: {
            Close(){
                if($(window.mouse.element).closest('.filter-popup').length > 0) return;
                this.Toggle(false);
            },
            Toggle(val){
                if(val !== undefined || val !== null) {
                    this.toggled = val;
                    return;
                }
                this.toggled = !this.toggled;
            },
            SanitizeInput() {
                this.newBusinessUnitName = this.newBusinessUnitName.replace(/[^A-Za-z0-9 \-]/g, '');
                if (this.newBusinessUnitName.length > 64) {
                    this.newBusinessUnitName = this.newBusinessUnitName.substring(0, 64);
                }
                return this.newBusinessUnitName;
            },
            Init(options){
                var view = this;
                this.toggled = true;
                if(options.elRelative){
                    this.elRelative = options.elRelative;
                }

                requestAnimationFrame(function(){
                    if(!view.elRelative) return;
                    var box = view.elRelative.getBoundingClientRect();
                    var widthTotal = window.innerWidth;
                    var heightTotal = window.innerHeight;
                    var posx = 190;
                    var posy = 0;
                    var offsety = 5;
                    var offsetyBottom = 120;
                    var userselectheight = 520;

                    if(heightTotal - (box.top + box.height + offsety) > userselectheight) {
                        posy = (box.top + box.height + offsety);
                    } else {
                        if(heightTotal < userselectheight || box.top - offsetyBottom - userselectheight < 0) {
                            posy = 5;
                        } else {
                            posy = box.top - offsetyBottom - userselectheight;
                        }
                    }
                    view.posx = posx;
                    view.posy = posy;
                });
            },
            
            createBusinessUnit: function(evt){
                this.SanitizeInput();
                let view = this;
                let url = '/api/sec/businessunit';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/businessunit');
                
                let payload = {
                storeId: this.$store.state.storeId,
                name: this.newBusinessUnitName,
                createWithSpotAndSkill: this.createWithSpotAndSkill,
                }

                this.axios({
                    method: 'post',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    console.log(response);
                    view.newBusinessUnitName = '';
                    view.Toggle(false);
                    view.$helpers.success('Erfolg', 'Ein neuer Bereich wurde angelegt!');
                    view.$parent.refresh();
                }).catch(function (error) {
                    console.log(error);
                })
            },
        },
        mounted() {
            $('html').append(this.$el);
        }
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .businessunit-popup{
        position:fixed;
        display:inline-block;
        max-height: 520px;
        width: 400px;
        border-radius: 5px;
        display:none;
        z-index: 1000;
        background: white;
        box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
        padding: 30px;

        top: 100px;
        left: 100px;
    }

     .background {
        position: fixed;
        height: 100vh;
        width: 100vw;
        left: 0;
        right: 0;
        z-index: -1;
        top: 0;
    }


    .header{
        margin-bottom:45px;
    }
    .header .label{
        box-shadow: inset 0 -1px 0 0px #ebebeb;
        font-size: 20px;
    }

    .fa-stack.cancel{
        cursor: pointer;
        position: absolute;
        top: 6px;
        right: 5px;
        font-size: 10px;
        transform: scale(.8);
    }
    .fa-stack.cancel .fa-circle{
    }
    .fa-stack.cancel .fa-times{
        font-size: 13px;
        transform: translateY(3px);
    }

    .button{
        border: inset 1px #808080;
        width: 100px;
        text-align: center;
    }

</style>
